export const EnumAPIKey = {
  API_VENDOR: 'API_VENDOR',
  API_BASE: 'API_BASE',
  API_CUSTOMER: 'API_CUSTOMER',
  API_HOTEL: 'API_BASE_HOTEL',
  API_TOUR: 'API_TOUR',
  API_STATIC: '',
}

export const apiConfig: any = {
  [EnumAPIKey.API_VENDOR]: process.env.NEXT_PUBLIC_API_BASE,
  [EnumAPIKey.API_TOUR]: process.env.NEXT_PUBLIC_API_BASE,
  [EnumAPIKey.API_BASE]: process.env.NEXT_PUBLIC_API_BASE,
  [EnumAPIKey.API_CUSTOMER]: process.env.NEXT_PUBLIC_API_BASE,
  [EnumAPIKey.API_HOTEL]: process.env.NEXT_PUBLIC_API_HOTEL,
  [EnumAPIKey.API_STATIC]: '/',
};